import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";

interface CenteredLoaderProps {
  animationPath?: string;
  size?: number;
}

const LoginWarning: React.FC<CenteredLoaderProps> = ({
  animationPath = "/animation/login_warning_animation.json",
  size = 400,
}) => {
  const [animationData, setAnimationData] = useState<any>(null);

  useEffect(() => {
    fetch(animationPath)
      .then((response) => response.json())
      .then((data) => setAnimationData(data))
      .catch((error) => console.error("Error loading Lottie animation:", error));
  }, [animationPath]);

  if (!animationData) {
    return <div>Loading...</div>;
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Lottie animationData={animationData} style={{ width: size, height: size }} />
    </div>
  );
};

export default LoginWarning;
